import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { format } from 'date-fns';
import { PremiumRideService } from 'src/app/services/premium-ride.service';
// import { ErrorComponent } from '../error/error.component';

@Component({
  selector: 'app-track-ride',
  templateUrl: './track-ride.component.html',
  styleUrls: ['./track-ride.component.scss'],
})
export class TrackRideComponent implements OnInit {

  @Input() rideData: any;
  @Input() premiumRouteInfo: any;

  initialRoute: any;
  finalRoute: any;

  refresherTimeout: any;

  constructor(
    private modalController: ModalController,
    private premiumRideService: PremiumRideService
  ) { }

  ngOnInit() {
    if(this.rideData.length > 0){
      this.initialRoute = this.rideData[0];
      this.finalRoute = this.rideData[this.rideData.length-1];
      this.reloadBusActivity();
    }
  }

  ionViewWillLeave(){
    clearInterval(this.refresherTimeout);
  }

  formatTime(date){
    if(date){
      return format(new Date(date), "h:mma");
    }
  }

  reloadBusActivity(){
    this.refresherTimeout = setInterval(() => {
      this.loadBusActivity();
    }, 15000)
  }

  loadBusActivity(){
    const payload = {
      bookedId: this.premiumRouteInfo?.bookedId
    }
    this.premiumRideService.trackRide(payload).toPromise().then((res) => {
      if(res){
        this.rideData = res?.details
        console.log({res});
      }
    }).catch(async response => {
      console.error('Track Ride error', response);
      const error = {
        status: 400,
        error: response?.message
      };    
      // const modal = await this.modalController.create({
      //   component: ErrorComponent,   
      //   cssClass: 'login-error-modal',
      //   componentProps: { error } 
      // });
      // await modal.present();
    });
  }

  dismiss(){
    clearInterval(this.refresherTimeout);
    this.modalController.dismiss();
  }
}
